import { usePage } from '@inertiajs/react';

function ReferralPrograms({
    text = __('Build and launch your own referral program, without writing a line of code.'),
    title = (launched_campaigns_count, extraText) => (
        <h1 className='text-[40px] font-bold leading-10'>
            We power <span className='text-blue'>{launched_campaigns_count}</span> referral
            programs across the globe {extraText}
        </h1>
    ),
    extraText = null,
}) {
    const {
        data: { launched_campaigns_count },
    } = usePage().props;

    return (
        <div className='relative z-10 max-w-[730px] text-center'>
            {title(launched_campaigns_count, extraText)}
            <p className='mt-10 flex max-w-[730px] justify-center text-lg sm:text-xl'>
                {text}
            </p>
        </div>
    );
}

export default ReferralPrograms;
